import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next'; // Import the useTranslation hook
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateJobCommentController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import ReactQuill from 'react-quill';
import SunTextEditor from "../../../Common/SunTextEditor";
import 'react-quill/dist/quill.snow.css';
import Draggable from 'react-draggable';
import Common from '../../../Common/Common';

import CommentTemplateService from "../../../Setup/controller/CommentTemplateController/CommentTemplateController";
function CreateAggNotification({ jobComment, JobID }) {
    const { t } = useTranslation(); // Initialize the useTranslation hook
    const [formData, setFormData] = useState({ IssueID: JobID, Comment: "",CommentType: "0",
        vc_ServiceCode: "" });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
      const [commentTemplatesData, setCommentTemplatesData] = useState([]);
        const [selectedTemplateID, setSelectedTemplateID] = useState("");
    let accordTheme = "accordion-header-light";
    if (theme === "dark") { // Corrected the comparison operator
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (jobComment) {
            setFormData({
                IssueID: JobID,
                Comment: jobComment.Comment,
                CommentType: jobComment.CommentType,
                vc_ServiceCode: jobComment.vc_ServiceCode,
            });
        } else {
            setFormData({ IssueID: JobID, Comment: "", CommentType: "0", vc_ServiceCode: "0" });
        }
    }, [jobComment, JobID]);

    useEffect(() => {
        const fetchCommentTemplates = async () => {
            try {
                const redirectCallback = () => navigate('/');
                const templates = await CommentTemplateService.GetAllCommentTemplates(redirectCallback);
                setCommentTemplatesData(templates);
            } catch (error) {
                console.error("Error fetching comment templates:", error);
            }
        };
        fetchCommentTemplates();
    }, [navigate]);

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        handleChange(e, formData, setFormData);

        // Reset selected template when switching between Add New / Templates
        if (name === "CommentType" && value === "0") {
            setSelectedTemplateID("");
            setFormData((prev) => ({ ...prev, Comment: "" }));
        }
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission
        if (jobComment) {
            formData.ID = jobComment.ID;
        } else {
            formData.ID = 0;
        }
        formData.IssueID = JobID;
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/JobsList?saved=true');
        };

        handleSubmit(event, formData, setFormData, setErrors, () => {
            let JobCostID = localStorage.getItem('JobCostID');
            JobCostID = JobCostID + 1;
            localStorage.setItem('JobCostID', JobCostID);
            //   onSuccess(); // Call onSuccess to reload data
            // redirectUserList();
        }, () => {
            let JobCostID = localStorage.getItem('JobCostID');
            JobCostID = JobCostID + 1;
            localStorage.setItem('JobCostID', JobCostID);
            // navigate("JobComment")
            //  onSuccess(); // Call onSuccess to reload data
            //  redirectUserList();
        });

    };
    const handleTemplateSelect = (e) => {
        const selectedID = e.target.value;
        setSelectedTemplateID(selectedID);

        // ✅ Update vc_ServiceCode in formData as well
        setFormData((prev) => ({
            ...prev,
            vc_ServiceCode: selectedID
        }));

        if (!selectedID) {
            setFormData((prev) => ({ ...prev, Comment: "" }));
            return;
        }

        const selectedTemplate = commentTemplatesData.find(
            (t) => t.ID.toString() === selectedID
        );
        if (selectedTemplate) {
            setFormData((prev) => ({
                ...prev,
                Comment: selectedTemplate.vc_Comment
            }));
        }
    };
    const handleEditorChange = (content) => {
        setFormData((prev) => ({ ...prev, Comment: content }));
    };

    return (
        <div>
            <Common />

        </div>
    );
}

export default CreateAggNotification;
